import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "switchBar" }
const _hoisted_2 = { class: "pagination" }
const _hoisted_3 = { style: {"background":"yellow","padding":"0.2em","margin":"0.2em","border":"1px solid #867f7f"} }
const _hoisted_4 = { style: {"display":"flex","justify-content":"start","align-items":"start"} }
const _hoisted_5 = ["href"]
const _hoisted_6 = { style: {"display":"flex","justify-content":"start","align-items":"start"} }
const _hoisted_7 = { style: {"display":"flex","justify-content":"start","align-items":"start"} }
const _hoisted_8 = { style: {"display":"flex","justify-content":"start","align-items":"start"} }
const _hoisted_9 = { style: {"display":"flex","justify-content":"start","align-items":"start"} }
const _hoisted_10 = { style: {"display":"flex","justify-content":"start","align-items":"start","flex-wrap":"wrap"} }
const _hoisted_11 = { style: {"display":"flex","justify-content":"start","align-items":"start"} }
const _hoisted_12 = { style: {"text-indent":"10%"} }
const _hoisted_13 = { style: {"display":"block"} }
const _hoisted_14 = { style: {"display":"block"} }
const _hoisted_15 = { style: {"display":"block","text-indent":"15%"} }
const _hoisted_16 = { style: {"display":"flex","justify-content":"start","align-items":"start"} }
const _hoisted_17 = { style: {"display":"flex","justify-content":"start","align-items":"start"} }
const _hoisted_18 = { style: {"display":"flex","justify-content":"start","align-items":"start"} }
const _hoisted_19 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_tabs, {
        modelValue: _ctx.activeName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeName) = $event)),
        type: "card",
        class: "demo-tabs",
        onTabClick: _ctx.handleClick
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            label: "待审核",
            name: "first"
          }),
          _createVNode(_component_el_tab_pane, {
            label: "通过",
            name: "second"
          }),
          _createVNode(_component_el_tab_pane, {
            label: "不通过",
            name: "third"
          })
        ]),
        _: 1
      }, 8, ["modelValue", "onTabClick"]),
      _createVNode(_component_el_table, {
        data: _ctx.tableData,
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "标题",
            prop: "gameTitle"
          }),
          _createVNode(_component_el_table_column, {
            label: "语言",
            prop: "gameLanguage"
          }),
          _createVNode(_component_el_table_column, {
            label: "单人/多人",
            prop: "gameClass"
          }),
          _createVNode(_component_el_table_column, {
            label: "创建时间",
            prop: "createTime"
          }),
          (_ctx.activeName == 'third')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                label: "备注",
                prop: "remark"
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, { align: "right" }, {
            default: _withCtx((scope) => [
              (_ctx.activeName == 'first')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "warning",
                    size: "small",
                    onClick: ($event: any) => {
              _ctx.handleEdit(scope.$index, scope.row);
              _ctx.centerDialogVisible = true;
            }
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode("审核", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.activeName == 'second')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    type: "danger",
                    size: "small",
                    onClick: ($event: any) => (_ctx.quash(scope.$index, scope.row))
                  }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createTextVNode("撤销", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_pagination, {
          background: "",
          layout: "prev, pager, next",
          total: _ctx.total,
          onCurrentChange: _ctx.handleCurrentChange
        }, null, 8, ["total", "onCurrentChange"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.centerDialogVisible,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.centerDialogVisible) = $event)),
      title: "",
      width: "900",
      center: "",
      draggable: ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_el_button, { onClick: _ctx.noPass }, {
            default: _withCtx(() => [...(_cache[78] || (_cache[78] = [
              _createTextVNode("不通过", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.pass
          }, {
            default: _withCtx(() => [...(_cache[79] || (_cache[79] = [
              _createTextVNode(" 通过 ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("p", null, "游戏标题：" + _toDisplayString(_ctx.form.gameTitle), 1),
          _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("p", null, "游戏价格：" + _toDisplayString(_ctx.form.purchaseMoney) + "元", 1),
          _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("p", null, "游戏创作者：" + _toDisplayString(_ctx.form.author), 1),
          _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("p", null, [
            _cache[8] || (_cache[8] = _createTextVNode(" 游戏标签：", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(_ctx.form.tips), (item) => {
              return (_openBlock(), _createElementBlock("b", _hoisted_3, _toDisplayString(item), 1))
            }), 256))
          ]),
          _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("p", null, "游戏简介：" + _toDisplayString(_ctx.form.gameDesc), 1),
          _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("p", null, "研学特点：" + _toDisplayString(_ctx.form.features), 1),
          _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("p", null, "游戏语言：" + _toDisplayString(_ctx.form.gameLanguage), 1),
          _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("p", null, "游戏模式：" + _toDisplayString(_ctx.form.gameClass), 1),
          _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("p", null, "游戏难度：" + _toDisplayString(_ctx.form.difficulty) + "星", 1),
          _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("p", null, "开始点：" + _toDisplayString(_ctx.form.beginPoint), 1),
          _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("p", null, "结束点：" + _toDisplayString(_ctx.form.endPoint), 1),
          _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("p", null, "预估时间：" + _toDisplayString(_ctx.form.estimateTime), 1),
          _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("p", null, "体验时间：" + _toDisplayString(_ctx.form.experienceTime), 1),
          _cache[31] || (_cache[31] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("p", null, "游玩人数：" + _toDisplayString(_ctx.form.multiplayer), 1),
          _cache[32] || (_cache[32] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("p", null, "适宜年龄：" + _toDisplayString(_ctx.form.playerAge), 1),
          _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("p", null, [
            _cache[10] || (_cache[10] = _createTextVNode(" 故事背景：", -1)),
            _createVNode(_component_el_button, {
              type: "info",
              onClick: _ctx.showLevel2,
              style: {"margin":"10px"}
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode("点击查看", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("p", null, [
            _cache[12] || (_cache[12] = _createTextVNode(" 内容编辑：", -1)),
            _createVNode(_component_el_button, {
              type: "info",
              onClick: _ctx.showLevel,
              style: {"margin":"10px"}
            }, {
              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                _createTextVNode("点击查看", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("p", null, [
            _cache[14] || (_cache[14] = _createTextVNode(" 游戏复盘：", -1)),
            _createVNode(_component_el_button, {
              type: "info",
              onClick: _ctx.showLevel3,
              style: {"margin":"10px"}
            }, {
              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                _createTextVNode("点击查看", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _cache[34] || (_cache[34] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("p", null, "开放时间：" + _toDisplayString(_ctx.form.openHour), 1),
          _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("p", _hoisted_4, [
            _cache[15] || (_cache[15] = _createElementVNode("span", null, "游学证明：", -1)),
            (_ctx.form.proveImg != null)
              ? (_openBlock(), _createBlock(_component_el_image, {
                  key: 0,
                  style: {"width":"200px","height":"400px"},
                  src: _ctx.form.proveImg,
                  fit: 'contain'
                }, null, 8, ["src"]))
              : _createCommentVNode("", true)
          ]),
          _cache[36] || (_cache[36] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("p", null, [
            _cache[16] || (_cache[16] = _createTextVNode(" 调查问卷：", -1)),
            _createElementVNode("a", {
              href: _ctx.form.feedbackLink,
              target: "_blank",
              style: {"color":"#2da8e0"}
            }, _toDisplayString(_ctx.form.feedbackLink), 9, _hoisted_5)
          ]),
          _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("p", null, "创建时间：" + _toDisplayString(_ctx.form.createTime), 1),
          _cache[38] || (_cache[38] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("p", null, "游玩时间：" + _toDisplayString(_ctx.form.playTime) + "分钟", 1),
          _cache[39] || (_cache[39] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("p", _hoisted_6, [
            _cache[17] || (_cache[17] = _createElementVNode("span", null, "游戏封面：", -1)),
            _createVNode(_component_el_image, {
              style: {"width":"200px","height":"200px"},
              src: _ctx.form.gameCover,
              fit: 'contain'
            }, null, 8, ["src"])
          ]),
          _cache[40] || (_cache[40] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("p", _hoisted_7, [
            _cache[18] || (_cache[18] = _createElementVNode("span", null, "自定义地图：", -1)),
            _createVNode(_component_el_image, {
              style: {"width":"200px","height":"200px"},
              src: _ctx.form.customizeMap,
              fit: 'contain'
            }, null, 8, ["src"])
          ])
        ]),
        _createVNode(_component_el_dialog, {
          modelValue: _ctx.startVisible,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.startVisible) = $event)),
          title: "",
          width: "500",
          center: "",
          draggable: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("p", null, "标题：" + _toDisplayString(_ctx.form3.startTitle), 1),
              _cache[42] || (_cache[42] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("p", null, "内容：" + _toDisplayString(_ctx.form3.startContent), 1),
              _cache[43] || (_cache[43] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("p", _hoisted_8, [
                _cache[41] || (_cache[41] = _createElementVNode("span", null, "地图：", -1)),
                _createVNode(_component_el_image, {
                  style: {"width":"200px","height":"200px"},
                  src: _ctx.form3.startImg,
                  fit: 'contain'
                }, null, 8, ["src"])
              ]),
              _cache[44] || (_cache[44] = _createElementVNode("br", null, null, -1))
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_dialog, {
          modelValue: _ctx.endVisible,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.endVisible) = $event)),
          title: "",
          width: "500",
          center: "",
          draggable: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("p", null, "标题：" + _toDisplayString(_ctx.form3.endTitle), 1),
              _cache[46] || (_cache[46] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("p", null, "内容：" + _toDisplayString(_ctx.form3.endContent), 1),
              _cache[47] || (_cache[47] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("p", _hoisted_9, [
                _cache[45] || (_cache[45] = _createElementVNode("span", null, "地图：", -1)),
                _createVNode(_component_el_image, {
                  style: {"width":"200px","height":"200px"},
                  src: _ctx.form3.endImg,
                  fit: 'contain'
                }, null, 8, ["src"])
              ]),
              _cache[48] || (_cache[48] = _createElementVNode("br", null, null, -1))
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_dialog, {
          modelValue: _ctx.levelVisible,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.levelVisible) = $event)),
          width: "700",
          title: "关卡",
          "append-to-body": ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_collapse, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form2, (item2) => {
                    return (_openBlock(), _createBlock(_component_el_collapse_item, {
                      title: item2.levelTitle,
                      name: item2.levelTitle
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", null, "地址：" + _toDisplayString(item2.address), 1),
                        _cache[57] || (_cache[57] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("p", null, "经度：" + _toDisplayString(item2.lat) + "，纬度：" + _toDisplayString(item2.lng), 1),
                        _cache[58] || (_cache[58] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("p", null, "地址提示内容：" + _toDisplayString(item2.addressTipContent), 1),
                        _cache[59] || (_cache[59] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("p", null, "地址提示名称：" + _toDisplayString(item2.addressTipName), 1),
                        _cache[60] || (_cache[60] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("p", _hoisted_10, [
                          _cache[49] || (_cache[49] = _createElementVNode("span", null, "关卡位置提示图：", -1)),
                          (item2.tipCover !== null)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item2.tipCover.split(','), (item3) => {
                                return (_openBlock(), _createBlock(_component_el_image, {
                                  style: {"width":"100px","height":"100px","margin-left":"10px"},
                                  src: item3,
                                  fit: 'contain'
                                }, null, 8, ["src"]))
                              }), 256))
                            : _createCommentVNode("", true)
                        ]),
                        _cache[61] || (_cache[61] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("p", null, "故事标题：" + _toDisplayString(item2.storyTitle), 1),
                        _cache[62] || (_cache[62] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("p", null, "故事内容：" + _toDisplayString(item2.storyDesc) + "星", 1),
                        _cache[63] || (_cache[63] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("p", _hoisted_11, [
                          _cache[50] || (_cache[50] = _createElementVNode("span", null, "故事图片：", -1)),
                          _createVNode(_component_el_image, {
                            style: {"width":"200px","height":"200px"},
                            src: item2.storyCover,
                            fit: 'contain'
                          }, null, 8, ["src"])
                        ]),
                        _cache[64] || (_cache[64] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("p", null, [
                          _cache[52] || (_cache[52] = _createTextVNode(" 选择题：", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(item2.questions), (item3) => {
                            return (_openBlock(), _createElementBlock("b", _hoisted_12, [
                              _createElementVNode("i", _hoisted_13, "问题:" + _toDisplayString(item3.value), 1),
                              _createElementVNode("i", _hoisted_14, "正确答案:" + _toDisplayString(item3.rightAnswer), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item3.options, (item4, index4) => {
                                return (_openBlock(), _createElementBlock("i", _hoisted_15, [
                                  _createElementVNode("p", null, _toDisplayString(index4 + 1) + "、" + _toDisplayString(item4.one), 1)
                                ]))
                              }), 256)),
                              _cache[51] || (_cache[51] = _createElementVNode("br", null, null, -1))
                            ]))
                          }), 256))
                        ]),
                        _cache[65] || (_cache[65] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("p", null, "难度：" + _toDisplayString(item2.difficulty) + "星", 1),
                        _cache[66] || (_cache[66] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("p", null, "关卡内容：" + _toDisplayString(item2.levelContent), 1),
                        _cache[67] || (_cache[67] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("p", _hoisted_16, [
                          _cache[53] || (_cache[53] = _createElementVNode("span", null, "关卡谜题内容：", -1)),
                          _createVNode(_component_el_image, {
                            style: {"width":"200px","height":"200px"},
                            src: item2.levelCover,
                            fit: 'contain'
                          }, null, 8, ["src"])
                        ]),
                        _cache[68] || (_cache[68] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("p", null, "关卡答案：" + _toDisplayString(item2.levelDesc), 1),
                        _cache[69] || (_cache[69] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("p", null, [
                          _cache[55] || (_cache[55] = _createTextVNode(" 提示列表：", -1)),
                          _createVNode(_component_el_button, {
                            type: "info",
                            onClick: ($event: any) => (_ctx.showTips(item2.tips)),
                            style: {"margin":"10px"}
                          }, {
                            default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                              _createTextVNode("点击查看", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _cache[70] || (_cache[70] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("p", null, "景点标题：" + _toDisplayString(item2.attractionsTitle), 1),
                        _cache[71] || (_cache[71] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("p", null, "景点内容：" + _toDisplayString(item2.attractions), 1),
                        _cache[72] || (_cache[72] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("p", _hoisted_17, [
                          _cache[56] || (_cache[56] = _createElementVNode("span", null, "景点图片：", -1)),
                          _createVNode(_component_el_image, {
                            style: {"width":"200px","height":"200px"},
                            src: item2.attractionsImage,
                            fit: 'contain'
                          }, null, 8, ["src"])
                        ]),
                        _cache[73] || (_cache[73] = _createElementVNode("br", null, null, -1))
                      ]),
                      _: 2
                    }, 1032, ["title", "name"]))
                  }), 256))
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_el_dialog, {
              modelValue: _ctx.tipVisible,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tipVisible) = $event)),
              width: "500",
              title: "提示",
              "append-to-body": ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_el_collapse, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form4, (item4) => {
                        return (_openBlock(), _createBlock(_component_el_collapse_item, {
                          title: item4.tipTitle,
                          name: item4.tipTitle
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", null, "提示标题：" + _toDisplayString(item4.tipTitle), 1),
                            _cache[75] || (_cache[75] = _createElementVNode("br", null, null, -1)),
                            _createElementVNode("p", null, "提示内容：" + _toDisplayString(item4.tipContent), 1),
                            _cache[76] || (_cache[76] = _createElementVNode("br", null, null, -1)),
                            _createElementVNode("p", _hoisted_18, [
                              _cache[74] || (_cache[74] = _createElementVNode("span", null, "提示图片：", -1)),
                              (item4.tipPicture != null)
                                ? (_openBlock(), _createBlock(_component_el_image, {
                                    key: 0,
                                    style: {"width":"200px","height":"200px"},
                                    src: item4.tipPicture,
                                    fit: 'contain'
                                  }, null, 8, ["src"]))
                                : _createCommentVNode("", true)
                            ]),
                            _cache[77] || (_cache[77] = _createElementVNode("br", null, null, -1))
                          ]),
                          _: 2
                        }, 1032, ["title", "name"]))
                      }), 256))
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _cache[80] || (_cache[80] = _createElementVNode("div", { class: "zhanwei3" }, null, -1))
  ], 64))
}